import { Alert } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const IncorporationDateAlertStyled = styled(Alert)`
  width: 100%;
`;
